import React from 'react';
import classNames from 'classnames';

// import {} from '@components';

interface Tab {
  text: React.ReactNode;
  value?: any;
  badge?: React.ReactNode;
}

interface Props {
  items: Array<Tab>;
  value: any;
  onClick?: (tab: Tab) => any;
}

const Tabs: React.FC<Props> = (props) => {
  const handleClick = (e: any, tab: Tab) => {
    e.preventDefault();
    if (typeof props.onClick === 'function') {
      props.onClick(tab);
    }
  };

  return (
    <div className="component-tabs">
      <ul className="component-tabs-items">
        {props.items.map((item, index) => (
          <li
            key={`${index}-${item.text}`}
            className={classNames('component-tabs-item', {
              isActive: item.value === props.value,
            })}
            onClick={(e) => handleClick(e, item)}
          >
            <span className="item-text">{item.text}</span>
            {!!item.badge && !isNaN(item.badge as any) && Number(item.badge) > 0 && (
              <span className="item-badge">{item.badge}</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Tabs;
